module.exports = __webpack_public_path__ + "img/screenshot-logs.1c32a07b.jpg";